
// initial state
const state = {
    loanTiers: [],
};

const getters = {
    loanTiers: state => {
        return state.loanTiers;
    },
};

const actions = {
    saveLoanTiers(context, loanTiers){
        context.commit('saveLoanTiers', loanTiers);
    },
};

const mutations = {
    saveLoanTiers(state, loanTiers){
        state.loanTiers = loanTiers;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}